<template>
    <div class="text-muted">
        <span class="mr-1">Gold:
            <span v-if="marketPrices.gold">${{ marketPrices.gold | toFixed2 }}</span>
            <span v-else><i class="fa-regular fa-spinner fa-spin fa-fw"></i></span>
        </span> |
        <span class="mx-1">Silver:
            <span v-if="marketPrices.silver">${{ marketPrices.silver | toFixed2 }}</span>
            <span v-else><i class="fa-regular fa-spinner fa-spin fa-fw"></i></span>
        </span> |
        <span class="mx-1">Platinum:
            <span v-if="marketPrices.platinum">${{ marketPrices.platinum | toFixed2 }}</span>
            <span v-else><i class="fa-regular fa-spinner fa-spin fa-fw"></i></span>
        </span> |
        <span class="ml-1">Palladium:
            <span v-if="marketPrices.palladium">${{ marketPrices.palladium | toFixed2 }}</span>
            <span v-else><i class="fa-regular fa-spinner fa-spin fa-fw"></i></span>
        </span>
    </div>
</template>

<script>
export default {
    name: 'HeaderMarket',
    data() {
        return {
            marketPrices: {
                gold: null,
                silver: null,
                platinum: null,
                palladium: null,
            },
        };
    },
    created() {
        this.getMarket();
    },
    methods: {
        getMarket() {
            this.$store.dispatch('LOAD_MARKET', (market) => {
                //console.log("registered time wait",market,  market.timeout,(new Date()).getTime(),market.timeout-(new Date()).getTime());
                this.marketPrices.gold = market.gold;
                this.marketPrices.silver = market.silver;
                this.marketPrices.platinum = market.platinum;
                this.marketPrices.palladium = market.palladium;
                setTimeout(() => {
                    this.getMarket();
                }, market.timeout-(new Date()).getTime());
            });
        }
    }
};
</script>

<style>

</style>
